/*
 * Espacio Unno · preguntas: una sola abierta a la vez.
 *
 * Quien abre y cierra sigue siendo eu.js (data-eu-acordeon / data-eu-pregunta);
 * esto sólo añade lo que en el sitio hacía el multiple={false} de Base UI:
 * al abrir una pregunta, se cierran las demás del mismo acordeón.
 *
 * Va delegado en el documento, así que escucha después de eu.js (que ya movió
 * aria-expanded) y sigue funcionando cuando el editor recarga la sección.
 */
(function () {
  "use strict";

  document.addEventListener("click", function (e) {
    var boton = e.target.closest ? e.target.closest("[data-eu-pregunta]") : null;
    if (!boton || boton.getAttribute("aria-expanded") !== "true") return;

    var raiz = boton.closest("[data-eu-acordeon]");
    if (!raiz) return;

    raiz.querySelectorAll("[data-eu-pregunta]").forEach(function (otro) {
      if (otro === boton || otro.getAttribute("aria-expanded") !== "true") return;
      otro.setAttribute("aria-expanded", "false");
      var panel = document.getElementById(otro.getAttribute("aria-controls"));
      if (panel) panel.hidden = true;
    });
  });
})();
